import { Typography, Box, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { AppLayout } from '../components/AppLayout';
import { AppHeader } from '../components/AppHeader';
import { AppFooter } from '../components/AppFooter';
import { Link } from '@mui/material';

/** 404 Not Found page for invalid routes */
export function NotFoundPage() {
  return (
    <AppLayout header={<AppHeader />} footer={<AppFooter />}>
      <Box sx={{ py: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 300 }}>
          Page not found
        </Typography>

        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary', maxWidth: '60ch' }}>
          The page you're looking for doesn't exist.
        </Typography>

        <Paper elevation={0} sx={{ p: 3, bgcolor: 'grey.50', borderRadius: 2, mb: 3 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            <Link
              component={RouterLink}
              to="/"
              sx={{ textDecoration: 'none', color: 'inherit', borderBottom: '1px solid' }}
            >
              Go to home page
            </Link>
          </Typography>
        </Paper>
      </Box>
    </AppLayout>
  );
}
